import api from "@/services/axios.js";
import {
  UnassignDriverRequest,
  UnassignDriverRequestPayload,
} from "../../types.ts";
import { searchHandler } from "../../lib/helpers.ts";

export const unassignDriverFromVerificationStages = (
  request: UnassignDriverRequest,
) => {
  const payload: UnassignDriverRequestPayload = {};

  if (request.selectingAll) {
    payload.searchVerificationsRequestViewModel = searchHandler(
      request.searchValues,
    );
  } else {
    payload.verificationStagesIds = request.verificationStagesIds;
  }

  return api.post(
    "/api/AdminVerification/unassign-driver-from-verification-stages",
    payload,
  );
};
